import * as RadixCheckbox from '@radix-ui/react-checkbox'
import React from 'react'
import styled from 'styled-components'

export type CheckboxProps = React.ComponentPropsWithRef<
  typeof RadixCheckbox.Root
> & {}

export const Checkbox = ({ checked, ...props }: CheckboxProps) => (
  <Root {...props} checked={checked}>
    <Indicator />
  </Root>
)

const Root = styled(RadixCheckbox.Root)`
  --indicator-background: var(--primary-9);
  --indicator-background-hover: var(--primary-10);

  width: 14px;
  height: 14px;
  border-radius: 4px;
  transition: all 0.15s linear;
  border: 1px solid var(--backgroundA-4);
  padding: 2px;

  background: var(--appearanceA-3, var(--appearanceA-3));

  cursor: pointer;

  &:hover {
    border-color: var(--backgroundA-5);
  }

  &[aria-checked='true'] {
    border-color: var(--primary-4);
    &:hover {
      border-color: var(--primary-5);
    }
  }

  &:disabled {
    border-color: var(--backgroundA-2);
    background: var(--appearanceA-1, var(--appearanceA-1));
    pointer-events: none;
  }
`

const Indicator = styled(RadixCheckbox.Indicator)`
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 2px;
  background: var(--indicator-background);

  &[data-state='checked'] {
    &:hover {
      background: var(--indicator-background-hover);
    }
  }

  flex-shrink: 0;
`
